import React, { useState } from "react";
import { parseMarketCodes } from "../utils/marketCodes";

// Controlled chip editor for market codes — no managed list (unlike FitmentEditor's cars),
// so no dropdown/create-row.
// Props: { value = [], onChange }
export default function MarketCodeEditor({ value = [], onChange, id }) {
  const [text, setText] = useState("");

  const removeAt = (i) => onChange(value.filter((_, idx) => idx !== i));

  const commit = (raw) => {
    const codes = parseMarketCodes(raw);
    if (codes.length === 0) { setText(""); return; }
    const existingLower = new Set(value.map((v) => v.toLowerCase()));
    const toAdd = [];
    for (const code of codes) {
      const lower = code.toLowerCase();
      if (existingLower.has(lower)) continue;
      existingLower.add(lower);
      toAdd.push(code);
    }
    if (toAdd.length > 0) onChange([...value, ...toAdd]);
    setText("");
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit(text);
    }
  };

  // Unlike FitmentEditor (blur DISCARDS unknown text — there's a canonical cars list backing
  // it), blur here COMMITS: there's no managed list to validate a code against, so discarding
  // typed text on blur would be silent data loss.
  const onBlur = () => commit(text);

  return (
    <div className="fitment-editor">
      {value.length > 0 && (
        <div className="fitment-chips">
          {value.map((code, i) => (
            <span key={`${code}-${i}`} className="fitment-chip">
              {code}
              <button type="button" className="fitment-chip__x" aria-label={`Hapus ${code}`}
                onClick={() => removeAt(i)}>×</button>
            </span>
          ))}
        </div>
      )}
      <input
        id={id}
        className="form-input"
        value={text}
        placeholder="Ketik kode lalu Enter (mis. MB 241942)"
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
      />
    </div>
  );
}
